export const SmartFolderErrorState = {
	OwnerDeactivated: 'owner-deactivated',
	OwnerLostAccess: 'owner-lost-access',
	FolderDeleted: 'folder-deleted',
	SyncTransientError: 'sync-transient-error',
	Empty3PFolder: 'empty-3p-folder',
	IndexingInProgress: 'indexing-in-progress',
} as const;

export type SmartFolderErrorState =
	(typeof SmartFolderErrorState)[keyof typeof SmartFolderErrorState];

/**
 * Maps BE SmartFolderSyncErrorType values to the corresponding SmartFolderErrorState
 * for display in the error screen. Returns null for unrecognised errors so
 * callers can fall back to their generic error handling.
 *
 * Keep the switch literals in sync with:
 * confluence-modules/domains/content-sync/content-sync-api/src/main/java/com/atlassian/confluence/modules/domains/contentsync/api/SmartFolderSyncErrorType.java
 *
 * BE persists confirmed smart folder broken states as smartFolderProperties.syncErrorType
 * and returns the same enum names from confluence_syncSmartFolder via errors[].extensions.errorType.
 */
export const getSyncErrorState = (errorType: string): SmartFolderErrorState | null => {
	switch (errorType) {
		case 'SYNC_CONFLUENCE_OWNER_INELIGIBLE':
		case 'SYNC_REMOTE_OWNER_DEACTIVATED':
			return SmartFolderErrorState.OwnerDeactivated;
		case 'SYNC_REMOTE_OWNER_LOST_ACCESS':
			return SmartFolderErrorState.OwnerLostAccess;
		case 'SYNC_REMOTE_FOLDER_DELETED':
			return SmartFolderErrorState.FolderDeleted;
		case 'SYNC_TRANSIENT_ERROR':
			return SmartFolderErrorState.SyncTransientError;
		case 'SYNC_EXTERNAL_FOLDER_EMPTY':
		case 'SYNC_SOURCE_FOLDER_EMPTY':
			return SmartFolderErrorState.Empty3PFolder;
		case 'SYNC_WAITING_FOR_TWG':
		case 'SYNC_INDEXING_IN_PROGRESS':
			return SmartFolderErrorState.IndexingInProgress;
		default:
			return null;
	}
};
